import DesignWrapper from "./DesignWrapper";
import { useEffect, useState } from "react";
import { useContext } from "react";
import GalleryContext from "../context/GalleryContext";

function Gallery() {
    const [images, setImages] = useState([]);
    const { galleryVisible } = useContext(GalleryContext);

    useEffect(() => {
        fetch(`/gallery.php?folder=${galleryVisible}`)
        .then(res => res.json())
        .then(data => setImages(data))
        .catch(err => console.error(err));
    }, [galleryVisible]);

    return (
        <article>
            <div className="gallery">
                {images.map((img, index) => {
                return (
                    <DesignWrapper source={img.src} width={img.width} height={img.height} alt={img.alt} loading="lazy" />
                )
            }
            )}
            </div>
        </article>
    )
}

export default Gallery;